import React, { useEffect } from "react";
import { useAppSelector } from "../../hooks/redux";
import styles from "./Documents.module.css";
import LayoutContentWrapper from "../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import ContentHeader from "../../components/Layout/Content/ContentHeader/ContentHeader";
import { getTextByLanguage } from "../../enums/utils/getTextByLanguage";
import { EnumPages } from "../../enums/EnumPages";
import { UIText } from "../../enums/UIText/UIText";
import { getLanguage } from "../../store/selectors/appSelector";
import { EnumDocuments } from "../../enums/EnumDocuments";
import { UXDocuments } from "../../enums/UXText/UXDocuments";
import clsx from "clsx";

import registrPDF from "../../uploads/documents/Свидетельство о регистрации.pdf";
import technicalSupportPDF from "../../uploads/documents/Положения о техподдержке МИС.pdf";
import systemDescriptionPDF from "../../uploads/documents/Описание МИС.pdf";
import instructionForUserPDF from "../../uploads/documents/МИСДемо общая инструкция.pdf";
import instructionForAdminPDF from "../../uploads/documents/Руководство администратора, описание жизненного цикла, порядка поддержки и обслуживания программного обеспечения.pdf";

interface IDocumentsObject {
	name: EnumDocuments;
	filepath: string;
}
export const documents: IDocumentsObject[] = [
	{
		name: EnumDocuments.certificateOfRegistration,
		filepath: registrPDF,
	},
	{
		name: EnumDocuments.systemDescription,
		filepath: systemDescriptionPDF,
	},
	{
		name: EnumDocuments.technicalSupport,
		filepath: technicalSupportPDF,
	},
	{
		name: EnumDocuments.instructionForUser,
		filepath: instructionForUserPDF,
	},
	{
		name: EnumDocuments.instructionForAdmin,
		filepath: instructionForAdminPDF,
	},
	// {
	// 	name: EnumDocuments.instructionForUser,
	// 	path: "/uploads/documents/"
	// }
];
const Documents = () => {
	const language = useAppSelector(getLanguage);

	useEffect(() => {
		document.title = `${UIText.nav.documents[language]} - ${UIText.mis[language]}`;
	}, [language]);

	const handleButtonClick = (docName: string) => {
		const doc = documents.find((doc) => doc.name === docName);
		if (doc) {
			window.open(doc.filepath, "_blank");
		}
	};

	return (
		<LayoutContentWrapper>
			<ContentHeader title={getTextByLanguage(UIText.nav.documents, language)} pageName={EnumPages.documents} />

			{documents.map((doc, index) => (
				<div
					className={clsx(styles.documentWrapper, styles.defaultWrapper)}
					style={{ textDecoration: "none", color: "inherit" }}
					key={`doc_${index}`}
					onClick={() => handleButtonClick(doc.name)}
				>
					{getTextByLanguage(UXDocuments.documents[doc.name], language)}
				</div>
			))}
		</LayoutContentWrapper>
	);
};

export default Documents;
